<div class="page-wrapper" [ngClass]="[theme === 'dark'? 'dark' : '']">
  <div class="content">
    <div class="order-details">
      <div class="content p-0">
        <div class="page-header">
          <div class="page-title">
            <h4>
              <span class="back-arrow cursor-pointer" (click)="goBack()">
                <svg _ngcontent-ng-c3931894352="" viewBox="0 0 24 24" width="20" height="20" stroke="#212B36" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1"><line _ngcontent-ng-c3931894352="" x1="19" y1="12" x2="5" y2="12"></line><polyline _ngcontent-ng-c3931894352="" points="12 19 5 12 12 5"></polyline></svg>
              </span>
              Pickup Request</h4>
          </div>
        </div>

        <div class="ptl-page">

          <!-- ==================== SECTION 1: New Pickup Request ==================== -->
          <div class="card">
            <div class="card-header" (click)="togglePickupRequest()">
              <div class="heading-left">
                <span class="chevron" [class.open]="isPickupRequestOpen">›</span>
                <div class="header-text">
                  <h3>New Pickup Request</h3>
                  <p>Create a pickup request and push it to the vendor in one step</p>
                </div>
              </div>
              <span class="badge badge-blue">Docket Manifest</span>
            </div>

            <div class="card-body" *ngIf="isPickupRequestOpen">

              <!-- Order Details -->
              <div class="section-label">ORDER DETAILS</div>
              <div class="form-grid grid-3">
                <div class="form-field">
                  <label>Order Source</label>
                  <select [(ngModel)]="pickupRequestForm.orderSource">
                    <option *ngFor="let src of orderSources" [value]="src.value">{{ src.label }}</option>
                  </select>
                </div>
                <div class="form-field">
                  <label>Customer <span class="required">*</span></label>
                  <ng-select [items]="customerLookup.items" bindLabel="accountName"
                    [typeahead]="customerLookup.input$" [loading]="customerLookup.loading"
                    [virtualScroll]="true" (scrollToEnd)="loadMore(customerLookup)"
                    appendTo="body" placeholder="Search customer"
                    [(ngModel)]="pickupRequestForm.customer">
                  </ng-select>
                </div>
                <div class="form-field">
                  <label>Consignee <span class="required">*</span></label>
                  <ng-select [items]="consigneeLookup.items" bindLabel="accountName"
                    [typeahead]="consigneeLookup.input$" [loading]="consigneeLookup.loading"
                    [virtualScroll]="true" (scrollToEnd)="loadMore(consigneeLookup)"
                    appendTo="body" placeholder="Search consignee"
                    [(ngModel)]="pickupRequestForm.consignee">
                  </ng-select>
                </div>
                <div class="form-field">
                  <label>Created By</label>
                  <select [(ngModel)]="pickupRequestForm.createdBy">
                    <option *ngFor="let cb of createdByOptions" [value]="cb">{{ cb }}</option>
                  </select>
                </div>
              </div>

              <!-- Shipment Details -->
              <div class="section-label">SHIPMENT DETAILS</div>
              <div class="form-grid grid-2">
                <div class="form-field">
                  <label>Pickup Address (From) <span class="required">*</span></label>
                  <input type="text" placeholder="Full pickup address" [(ngModel)]="pickupRequestForm.pickupAddress" />
                </div>
                <div class="form-field">
                  <label>Delivery Address (To) <span class="required">*</span></label>
                  <input type="text" placeholder="Full delivery address" [(ngModel)]="pickupRequestForm.deliveryAddress" />
                </div>

                <!-- FROM: state, city, pincode, zone -->
                <div class="form-field">
                  <label>From State</label>
                  <ng-select #fromStateSel [multiple]="false" [(ngModel)]="pickupRequestForm.fromStateId" appendTo="body" placeholder="">
                    <ng-option *ngFor="let item of state" [value]="item.id">{{ item?.name }}</ng-option>
                    <ng-template ng-footer-tmp>
                      <div class="d-flex justify-content-end">
                        <button class="btn ng-select-btn btn-primary ms-1" (click)="create('state', fromStateSel)">Add More</button>
                      </div>
                    </ng-template>
                  </ng-select>
                </div>
                <div class="form-field">
                  <label>To State</label>
                  <ng-select #toStateSel [multiple]="false" [(ngModel)]="pickupRequestForm.toStateId" appendTo="body" placeholder="">
                    <ng-option *ngFor="let item of state" [value]="item.id">{{ item?.name }}</ng-option>
                    <ng-template ng-footer-tmp>
                      <div class="d-flex justify-content-end">
                        <button class="btn ng-select-btn btn-primary ms-1" (click)="create('state', toStateSel)">Add More</button>
                      </div>
                    </ng-template>
                  </ng-select>
                </div>
                <div class="form-field">
                  <label>From City <span class="required">*</span></label>
                  <ng-select #fromCitySel [multiple]="false" [(ngModel)]="pickupRequestForm.fromCityId" appendTo="body" placeholder="">
                    <ng-option *ngFor="let item of city" [value]="item.id">{{ item?.name }}</ng-option>
                    <ng-template ng-footer-tmp>
                      <div class="d-flex justify-content-end">
                        <button class="btn ng-select-btn btn-primary ms-1" (click)="create('city', fromCitySel)">Add More</button>
                      </div>
                    </ng-template>
                  </ng-select>
                </div>
                <div class="form-field">
                  <label>To City <span class="required">*</span></label>
                  <ng-select #toCitySel [multiple]="false" [(ngModel)]="pickupRequestForm.toCityId" appendTo="body" placeholder="">
                    <ng-option *ngFor="let item of city" [value]="item.id">{{ item?.name }}</ng-option>
                    <ng-template ng-footer-tmp>
                      <div class="d-flex justify-content-end">
                        <button class="btn ng-select-btn btn-primary ms-1" (click)="create('city', toCitySel)">Add More</button>
                      </div>
                    </ng-template>
                  </ng-select>
                </div>
                <div class="form-field">
                  <label>From Pincode <span class="required">*</span></label>
                  <input type="text" maxlength="6" placeholder="e.g. 400001" [(ngModel)]="pickupRequestForm.fromPincode" />
                </div>
                <div class="form-field">
                  <label>To Pincode <span class="required">*</span></label>
                  <input type="text" maxlength="6" placeholder="e.g. 110001" [(ngModel)]="pickupRequestForm.toPincode" />
                </div>
                <div class="form-field">
                  <label>From Zone</label>
                  <ng-select #fromZoneSel [multiple]="false" [(ngModel)]="pickupRequestForm.fromZoneId" appendTo="body" placeholder="">
                    <ng-option *ngFor="let item of zone" [value]="item.id">{{ item?.name }}</ng-option>
                    <ng-template ng-footer-tmp>
                      <div class="d-flex justify-content-end">
                        <button class="btn ng-select-btn btn-primary ms-1" (click)="create('zone', fromZoneSel)">Add More</button>
                      </div>
                    </ng-template>
                  </ng-select>
                </div>
                <div class="form-field">
                  <label>To Zone</label>
                  <ng-select #toZoneSel [multiple]="false" [(ngModel)]="pickupRequestForm.toZoneId" appendTo="body" placeholder="">
                    <ng-option *ngFor="let item of zone" [value]="item.id">{{ item?.name }}</ng-option>
                    <ng-template ng-footer-tmp>
                      <div class="d-flex justify-content-end">
                        <button class="btn ng-select-btn btn-primary ms-1" (click)="create('zone', toZoneSel)">Add More</button>
                      </div>
                    </ng-template>
                  </ng-select>
                </div>

                <div class="form-field">
                  <label>Actual Weight (kg)</label>
                  <input type="number" placeholder="0.00" [(ngModel)]="pickupRequestForm.actualWeight" />
                </div>
                <div class="form-field">
                  <label>Vol. Weight (kg)</label>
                  <input type="number" placeholder="0.00" [(ngModel)]="pickupRequestForm.volWeight" />
                </div>
                <div class="form-field">
                  <label>No. of Boxes</label>
                  <input type="number" [(ngModel)]="pickupRequestForm.noOfBoxes" />
                </div>
                <div class="form-field">
                  <label>PO Number</label>
                  <input type="text" placeholder="e.g. PO-2024-00123" [(ngModel)]="pickupRequestForm.poNumber" />
                </div>
              </div>

              <!-- Vendor & Delivery -->
              <div class="section-label">VENDOR &amp; DELIVERY</div>
              <div class="form-grid grid-3">
                <div class="form-field">
                  <label>Assign Vendor <span class="required">*</span></label>
                  <ng-select [items]="vendorLookup.items" bindLabel="vendorName"
                    [typeahead]="vendorLookup.input$" [loading]="vendorLookup.loading"
                    [virtualScroll]="true" (scrollToEnd)="loadMore(vendorLookup)"
                    appendTo="body" placeholder="Search vendor"
                    [(ngModel)]="pickupRequestForm.vendor">
                  </ng-select>
                </div>
                <div class="form-field">
                  <label>Delivery Type</label>
                  <select [(ngModel)]="pickupRequestForm.deliveryType">
                    <option *ngFor="let dt of deliveryTypes" [value]="dt">{{ dt }}</option>
                  </select>
                </div>
                <div class="form-field">
                  <label>Vendor Docket No. <span class="hint">(if no API)</span></label>
                  <input type="text" placeholder="Enter if no integration" [(ngModel)]="pickupRequestForm.vendorDocketNo" />
                </div>
              </div>

              <!-- Documents -->
              <div class="section-label">DOCUMENTS <span class="hint">(Configurable per Customer)</span></div>
              <div class="form-grid grid-2">
                <div class="upload-box">
                  <span class="upload-icon">📎</span>
                  <span class="upload-title">Upload PO / Product Invoice</span>
                  <span class="upload-sub">PDF, JPG, PNG accepted</span>
                </div>
                <div class="upload-box">
                  <span class="upload-icon">📎</span>
                  <span class="upload-title">Upload POD (if available)</span>
                  <span class="upload-sub">PDF, JPG, PNG accepted — optional</span>
                </div>
              </div>

              <div class="card-footer">
                <span class="required-note">Fields marked <span class="required">*</span> are required</span>
                <div class="footer-actions">
                  <button class="btn btn-outline" (click)="saveDraft()">
                    <span class="btn-icon">🖹</span> Save Draft
                  </button>
                  <button class="btn btn-success" (click)="sendToVendor()">
                    <span class="btn-icon">➤</span> Send to Vendor (API / Email / WhatsApp)
                  </button>
                  <button class="btn btn-primary" [disabled]="isSavingOrder" (click)="createOrder()">
                    <span class="btn-icon">⊕</span> Create Order
                  </button>
                </div>
              </div>

            </div>
          </div>

          <!-- ==================== SECTION 2: Create Intimation ==================== -->
          <div class="card">
            <div class="card-header" (click)="toggleIntimation()">
              <div class="heading-left">
                <span class="chevron" [class.open]="isIntimationOpen">›</span>
                <div class="header-text">
                  <h3>Create Intimation</h3>
                  <p>Send a pickup request to vendor before a docket is generated — no docket number at this stage. Customers can submit this directly.</p>
                </div>
              </div>
              <span class="badge badge-orange">Pre-Docket Manifest</span>
            </div>

            <div class="card-body" *ngIf="isIntimationOpen">

              <div class="form-grid grid-3">
                <div class="form-field">
                  <label>Customer <span class="required">*</span></label>
                  <ng-select [items]="customerLookup.items" bindLabel="accountName"
                    [typeahead]="customerLookup.input$" [loading]="customerLookup.loading"
                    [virtualScroll]="true" (scrollToEnd)="loadMore(customerLookup)"
                    appendTo="body" placeholder="Search customer"
                    [(ngModel)]="intimationForm.customer">
                  </ng-select>
                </div>
                <div class="form-field">
                  <label>Assign Vendor <span class="required">*</span></label>
                  <ng-select [items]="vendorLookup.items" bindLabel="vendorName"
                    [typeahead]="vendorLookup.input$" [loading]="vendorLookup.loading"
                    [virtualScroll]="true" (scrollToEnd)="loadMore(vendorLookup)"
                    appendTo="body" placeholder="Search vendor"
                    [(ngModel)]="intimationForm.vendor">
                  </ng-select>
                </div>
                <div class="form-field">
                  <label>Consignee <span class="hint">(end brand/marketplace)</span></label>
                  <ng-select [items]="consigneeLookup.items" bindLabel="accountName"
                    [typeahead]="consigneeLookup.input$" [loading]="consigneeLookup.loading"
                    [virtualScroll]="true" (scrollToEnd)="loadMore(consigneeLookup)"
                    appendTo="body" placeholder="Search consignee"
                    [(ngModel)]="intimationForm.consignee">
                  </ng-select>
                </div>
                <div class="form-field">
                  <label>Order Source</label>
                  <select [(ngModel)]="intimationForm.orderSource">
                    <option *ngFor="let src of intimationOrderSources" [value]="src.value">{{ src.label }}</option>
                  </select>
                </div>
              </div>

              <div class="section-label">SHIPMENT DETAILS</div>
              <div class="form-grid grid-2">
                <div class="form-field">
                  <label>Pickup Address (From) <span class="required">*</span></label>
                  <input type="text" placeholder="Full pickup address" [(ngModel)]="intimationForm.pickupAddress" />
                </div>
                <div class="form-field">
                  <label>Delivery Address (To) <span class="required">*</span></label>
                  <input type="text" placeholder="Full delivery address" [(ngModel)]="intimationForm.deliveryAddress" />
                </div>

                <div class="form-field">
                  <label>From State</label>
                  <ng-select #iFromStateSel [multiple]="false" [(ngModel)]="intimationForm.fromStateId" appendTo="body" placeholder="">
                    <ng-option *ngFor="let item of state" [value]="item.id">{{ item?.name }}</ng-option>
                    <ng-template ng-footer-tmp>
                      <div class="d-flex justify-content-end">
                        <button class="btn ng-select-btn btn-primary ms-1" (click)="create('state', iFromStateSel)">Add More</button>
                      </div>
                    </ng-template>
                  </ng-select>
                </div>
                <div class="form-field">
                  <label>To State</label>
                  <ng-select #iToStateSel [multiple]="false" [(ngModel)]="intimationForm.toStateId" appendTo="body" placeholder="">
                    <ng-option *ngFor="let item of state" [value]="item.id">{{ item?.name }}</ng-option>
                    <ng-template ng-footer-tmp>
                      <div class="d-flex justify-content-end">
                        <button class="btn ng-select-btn btn-primary ms-1" (click)="create('state', iToStateSel)">Add More</button>
                      </div>
                    </ng-template>
                  </ng-select>
                </div>
                <div class="form-field">
                  <label>From City <span class="required">*</span></label>
                  <ng-select #iFromCitySel [multiple]="false" [(ngModel)]="intimationForm.fromCityId" appendTo="body" placeholder="">
                    <ng-option *ngFor="let item of city" [value]="item.id">{{ item?.name }}</ng-option>
                    <ng-template ng-footer-tmp>
                      <div class="d-flex justify-content-end">
                        <button class="btn ng-select-btn btn-primary ms-1" (click)="create('city', iFromCitySel)">Add More</button>
                      </div>
                    </ng-template>
                  </ng-select>
                </div>
                <div class="form-field">
                  <label>To City <span class="required">*</span></label>
                  <ng-select #iToCitySel [multiple]="false" [(ngModel)]="intimationForm.toCityId" appendTo="body" placeholder="">
                    <ng-option *ngFor="let item of city" [value]="item.id">{{ item?.name }}</ng-option>
                    <ng-template ng-footer-tmp>
                      <div class="d-flex justify-content-end">
                        <button class="btn ng-select-btn btn-primary ms-1" (click)="create('city', iToCitySel)">Add More</button>
                      </div>
                    </ng-template>
                  </ng-select>
                </div>
                <div class="form-field">
                  <label>From Pincode <span class="required">*</span></label>
                  <input type="text" maxlength="6" placeholder="e.g. 400001" [(ngModel)]="intimationForm.fromPincode" />
                </div>
                <div class="form-field">
                  <label>To Pincode <span class="required">*</span></label>
                  <input type="text" maxlength="6" placeholder="e.g. 110001" [(ngModel)]="intimationForm.toPincode" />
                </div>
                <div class="form-field">
                  <label>Approx. Weight (kg)</label>
                  <input type="number" placeholder="0.00" [(ngModel)]="intimationForm.approxWeight" />
                </div>
                <div class="form-field">
                  <label>No. of Boxes</label>
                  <input type="number" [(ngModel)]="intimationForm.noOfBoxes" />
                </div>
              </div>

              <div class="section-label">DELIVERY</div>
              <div class="form-grid grid-2">
                <div class="form-field">
                  <label>Delivery Type</label>
                  <select [(ngModel)]="intimationForm.deliveryType">
                    <option *ngFor="let dt of deliveryTypes" [value]="dt">{{ dt }}</option>
                  </select>
                </div>
                <div class="form-field">
                  <label>Remarks for Vendor</label>
                  <input type="text" placeholder="Any special instructions..." [(ngModel)]="intimationForm.remarks" />
                </div>
              </div>

              <div class="card-footer">
                <span class="required-note">A Docket Manifest number will be assigned once vendor confirms and picks up</span>
                <div class="footer-actions">
                  <button class="btn btn-success" [disabled]="isSendingIntimation" (click)="sendIntimation()">
                    <span class="btn-icon">➤</span> Send Intimation
                  </button>
                </div>
              </div>

            </div>
          </div>

          <!-- ==================== SECTION 3: Recent Pickup Requests & Intimations ==================== -->
          <!-- <div class="card">
            <div class="card-header no-toggle">
              <div class="heading-left">
                <div class="header-text">
                  <h3>Recent Pickup Requests &amp; Intimations</h3>
                </div>
              </div>
              <button class="btn btn-outline" (click)="viewAllOrders()">
                <span class="btn-icon">▤</span> View All Orders
              </button>
            </div>

            <div class="table-wrap">
              <table class="orders-table">
                <thead>
                  <tr>
                    <th>Ref / Docket</th>
                    <th>Type</th>
                    <th>Customer</th>
                    <th>Consignee</th>
                    <th>Vendor</th>
                    <th>Route</th>
                    <th>Delivery Type</th>
                    <th>Appt. Slot</th>
                    <th>Vendor Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let order of recentOrders">
                    <td [class.muted]="!order.hasDocket">{{ order.refDocket }}</td>
                    <td>
                      <span class="badge" [ngClass]="order.type === 'Docket Manifest' ? 'badge-blue' : 'badge-orange'">
                        {{ order.type }}
                      </span>
                    </td>
                    <td>{{ order.customer }}</td>
                    <td><span class="pill">{{ order.consignee }}</span></td>
                    <td>{{ order.vendor }}</td>
                    <td>{{ order.fromCity }} → {{ order.toCity }}</td>
                    <td>
                      <span class="pill" [class.pill-blue]="order.deliveryType === 'Appointment'">
                        {{ order.deliveryType }}
                      </span>
                    </td>
                    <td>{{ order.apptSlot }}</td>
                    <td>
                      <span class="status"
                        [ngClass]="{
                          'status-accepted': order.vendorStatus === 'Accepted',
                          'status-pending': order.vendorStatus === 'Pending',
                          'status-rejected': order.vendorStatus === 'Rejected'
                        }">
                        <ng-container [ngSwitch]="order.vendorStatus">
                          <span *ngSwitchCase="'Accepted'">✓ Accepted</span>
                          <span *ngSwitchCase="'Pending'">Pending</span>
                          <span *ngSwitchCase="'Rejected'">Rejected</span>
                        </ng-container>
                      </span>
                    </td>
                    <td class="actions-cell">
                      <ng-container [ngSwitch]="order.vendorStatus">
                        <ng-container *ngSwitchCase="'Accepted'">
                          <button class="btn btn-xs btn-outline" (click)="onRowAction('sync', order)">↻ Sync</button>
                          <button class="btn btn-xs btn-outline" (click)="onRowAction('track', order)">📍 Track</button>
                        </ng-container>
                        <ng-container *ngSwitchCase="'Pending'">
                          <button class="btn btn-xs btn-success" (click)="onRowAction('push', order)">➤ Push</button>
                        </ng-container>
                        <ng-container *ngSwitchCase="'Rejected'">
                          <button class="btn btn-xs btn-outline" (click)="onRowAction('re-push', order)">↻ Re-push</button>
                          <button class="btn btn-xs btn-outline" (click)="onRowAction('track', order)">📍 Track</button>
                        </ng-container>
                      </ng-container>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div> -->

        </div>

      </div>
    </div>
  </div>
</div>